export default __webpack_public_path__ + "static/media/Scratchy.bf2f3cae.jpg";